import { SmtpConfig } from '../../../config/email';

export interface EmailConfig {
  smtp: SmtpConfig;
  defaultFrom: string;
  maxRetries: number;
  retryDelay: number;
}

export const emailConfig: EmailConfig = {
  smtp: {
    host: import.meta.env.VITE_SMTP_HOST || 'localhost',
    port: Number(import.meta.env.VITE_SMTP_PORT) || 25,
    secure: import.meta.env.VITE_SMTP_SECURE === 'true',
    contactEmail: import.meta.env.VITE_CONTACT_EMAIL || 'contact@scalenix.fr'
  },
  defaultFrom: 'noreply@scalenix.fr',
  maxRetries: 3,
  retryDelay: 1000
};